
import { defineComponent, reactive } from 'vue'
import { useFreeSubscriptionsModule } from '@/modules/free-subscriptions'
import { useRoute } from 'vue-router'
import { FreeSubscriptionsRouteNames } from '@/router/routes-names'
import FreeSubscriptionsFilter from '@/components/free-subscriptions/free-subscriptions-filter.vue'
import { FreeSubscriptionSearchFilter } from '@/views/_shared/search-list/types'
import { FormModelCacheTag, restoreFormModelTo } from '@/modules/_shared/forms'
import FreeSubscriptionsList from '@/components/free-subscriptions/free-subscriptions-list.vue'

export default defineComponent({
    name: 'view-free-subscriptions',
    components: { FreeSubscriptionsFilter, FreeSubscriptionsList },
    props: {
        restoreFilters: {
            type: [Boolean, String]
        }
    },
    async setup (props) {
        const { getFreeSubscriptions, freeSubscriptions, freeSubscriptionsFilter } = useFreeSubscriptionsModule()
        const route = useRoute()

        if (props.restoreFilters !== false) {
            restoreFormModelTo(freeSubscriptionsFilter.search, FormModelCacheTag.FREE_SUBSCRIPTIONS_LIST_FILTERS)
        }

        let filter = freeSubscriptionsFilter.search as FreeSubscriptionSearchFilter
        filter = reactive(filter)

        function onResetFilters () {
            filter.subscriptionType = ''
            filter.processType = ''
            filter.createdBy = ''
            filter.user = ''
            filter.id = ''
            filter.startDate = ''
            filter.endDate = ''
        }

        await getFreeSubscriptions()

        return {
            freeSubscriptions,
            FreeSubscriptionsRouteNames,
            filter,
            onResetFilters,
            route
        }
    }
})
